import { useEffect } from 'react'
import { ConfigProvider, theme as antdTheme } from 'antd'
import { useThemeStore } from '@stores/themeStore'
import type { ReactNode } from 'react'

interface ThemeProviderProps {
  children: ReactNode
}

export const ThemeProvider = ({ children }: ThemeProviderProps) => {
  const currentTheme = useThemeStore((state) => state.theme)

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', currentTheme)
  }, [currentTheme])

  return (
    <ConfigProvider
      theme={{
        algorithm: currentTheme === 'dark' ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
        token: {
          colorPrimary: '#1f8efa',
          borderRadius: 10,
          colorBgContainer: currentTheme === 'dark' ? '#1e293b' : '#ffffff',
          colorBgElevated: currentTheme === 'dark' ? '#1e293b' : '#ffffff',
          colorBorder: currentTheme === 'dark' ? '#334155' : '#e2e8f0',
          colorText: currentTheme === 'dark' ? '#f1f5f9' : '#0f172a',
          colorTextSecondary: currentTheme === 'dark' ? '#94a3b8' : '#64748b'
        }
      }}
      warning={{
        strict: false,
      }}
    >
      {children}
    </ConfigProvider>
  )
}

